import { BOOptionModel } from "../../../../../data-model/boOptionModel";
import { FirestoreDocumentReference } from "../../../../../../shared/api/firebase/references";
import { ModalId } from "../../../../../../shared/enums/modalId";
import { useOptionsConfig } from "./useOptionsConfig";

export const useBoOptions = (selectedOrgId: string) => {
  return useOptionsConfig<BOOptionModel>({
    selectedOrgId,
    fetchDocumentRef: FirestoreDocumentReference.boOptions,
    documentKey: "bo_options",
    modalId: ModalId.BO_OPTIONS_MODAL,
    deleteModalId: ModalId.BO_OPTIONS_DELETE_MODAL,
    getUniqueKey: (item) => item.value,
    sortFields: ["priority"],
  });
};
